const DEPOSIT_FLAG = 'dwDepositEnabled';
const WITHDRAW_FLAG = 'dwWithdrawEnabled';

/** Temporary: show Withdraw only for this client while payout is in development. */
const WITHDRAW_ALLOWED_CLIENT_IDS = [127499];

export function clearDepositWithdrawFlags() {
  localStorage.removeItem(DEPOSIT_FLAG);
  localStorage.removeItem(WITHDRAW_FLAG);
}

export function setDepositWithdrawFlags(details) {
  if (!details || typeof details !== 'object') {
    return;
  }
  if (typeof details.depositEnabled === 'boolean') {
    localStorage.setItem(DEPOSIT_FLAG, details.depositEnabled ? '1' : '0');
  }
  if (typeof details.withdrawEnabled === 'boolean') {
    localStorage.setItem(WITHDRAW_FLAG, details.withdrawEnabled ? '1' : '0');
  }
}

function isEnabled(details, field, storageKey) {
  if (details && typeof details[field] === 'boolean') {
    return details[field];
  }
  return localStorage.getItem(storageKey) !== '0';
}

export function canUseDeposit(userDetails) {
  return isEnabled(userDetails, 'depositEnabled', DEPOSIT_FLAG);
}

export function canUseWithdraw(userDetails, clientId) {
  const id = Number(userDetails?.clientId || clientId || localStorage.getItem('userId'));
  if (!WITHDRAW_ALLOWED_CLIENT_IDS.includes(id)) {
    return false;
  }
  return isEnabled(userDetails, 'withdrawEnabled', WITHDRAW_FLAG);
}

export function canUseDepositWithdraw(userDetails, clientId) {
  return canUseDeposit(userDetails) || canUseWithdraw(userDetails, clientId);
}
